/** 한국 증시 정규장 오픈 여부 (KST 09:00–15:30, 평일·비공휴일) */

const KOREAN_HOLIDAYS = new Set([
  // 2025
  '2025-01-01', '2025-01-28', '2025-01-29', '2025-01-30',
  '2025-03-01', '2025-05-05', '2025-05-06', '2025-06-06',
  '2025-08-15', '2025-10-03', '2025-10-06', '2025-10-07', '2025-10-08',
  '2025-10-09', '2025-12-25',
  // 2026
  '2026-01-01', '2026-02-16', '2026-02-17', '2026-02-18',
  '2026-03-01', '2026-05-05', '2026-05-24', '2026-06-06',
  '2026-08-15', '2026-09-24', '2026-09-25', '2026-09-26',
  '2026-10-03', '2026-10-09', '2026-12-25',
]);

function toKoreaDate(date = new Date()) {
  return new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Seoul' }));
}

export function isKoreanHoliday(date = new Date()) {
  const k = toKoreaDate(date);
  const y = k.getFullYear();
  const m = String(k.getMonth() + 1).padStart(2, '0');
  const d = String(k.getDate()).padStart(2, '0');
  return KOREAN_HOLIDAYS.has(`${y}-${m}-${d}`);
}

export function isTradingHours(date = new Date()) {
  const k = toKoreaDate(date);
  const day = k.getDay();
  if (day < 1 || day > 5) return false;
  const hour = k.getHours();
  const minutes = k.getMinutes();
  return hour >= 9 && (hour < 15 || (hour === 15 && minutes <= 30));
}

export function isMarketOpen(date = new Date()) {
  const k = toKoreaDate(date);
  const day = k.getDay();
  const weekday = day >= 1 && day <= 5;
  return weekday && !isKoreanHoliday(date) && isTradingHours(date);
}

/** @returns {{ open: boolean, label: string, detail: string }} */
export function getMarketStatus(date = new Date()) {
  const open = isMarketOpen(date);
  const k = toKoreaDate(date);
  const time = k.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit', hour12: false });
  return {
    open,
    label: open ? '장 오픈' : '장 마감',
    detail: open ? `정규장 주문 가능 · ${time} KST` : `정규장 종료 · ${time} KST (평일 09:00–15:30)`,
  };
}
